module.exports = __webpack_public_path__ + "img/header-md.058753f6.png";